import { useEffect, useRef, useState } from 'react';

const useAutoClose = (enableScrollClose: boolean = false) => {
  const [showPopup, setShowPopup] = useState<boolean>(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const closeMenu = (e: MouseEvent | Event) => {
      if (
        showPopup &&
        ref.current &&
        !ref.current.contains(e.target as Node) &&
        (enableScrollClose || !Boolean(isScrollEventWithinContent(e)))
      ) {
        setShowPopup(false);
      }
    };

    const isScrollEventWithinContent = (e: Event): boolean | null => {
      // Check if the scroll event target is within the content
      return ref.current && ref.current.contains((e.target as HTMLElement) || null);
    };

    // Add event listeners for mouse click and scroll events only if enableScrollClose is true
    document.addEventListener('mousedown', closeMenu);
    if (enableScrollClose) {
      document.addEventListener('scroll', closeMenu);
    }

    return () => {
      // Remove event listeners when the component unmounts
      document.removeEventListener('mousedown', closeMenu);
      if (enableScrollClose) {
        document.removeEventListener('scroll', closeMenu);
      }
    };
    // eslint-disable-next-line
  }, [showPopup]);


  

  const tooglepopup = (): void => {
    setShowPopup(!showPopup);
  };

  const closepopup = () => {
    setShowPopup(false);
  };


  return { showPopup, ref, tooglepopup, closepopup };
};

export default useAutoClose;
